import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { initAuth } from "../services/AuthService";
import ccLogo from "../assets/logo/cc_logo.png";

export default function AuthInitializer({ children }) {
    const [checking, setChecking] = useState(true);
    const dispatch = useDispatch();
    const refreshToken = localStorage.getItem("authData")
        ? JSON.parse(localStorage.getItem("authData")).refreshToken
        : null;

    useEffect(() => {
        if (refreshToken) {
            dispatch(initAuth())
                .catch(() => { })
                .finally(() => setChecking(false));
        } else {
            setChecking(false);
        }
    }, [dispatch]);

    if (checking) {
        return (
            <div style={{
                position: "fixed",
                inset: 0,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                // backgroundColor: "#1E1D21",
            }}>
                <img src={ccLogo} alt="ChaaChingg" style={{ width: 100, height: "auto" }} />
            </div>
        );
    }

    return children;
}
